module.exports = __webpack_public_path__ + "img/header-navigation-below-mazda.f5a26cfc.png";